import { OcrResult } from "@finway-group/shared/lib/models"
import { roundNumberTo2Decimals } from "@finway-group/shared/lib/utils"
import { Col, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { SectionHeader, SummaryRow } from "./shared"

interface SummaryProps {
    data: OcrResult
}

export const EInvoiceSummary = ({ data }: SummaryProps) => {
    const { t } = useTranslation()
    if (!data.eInvoiceData?.totals) {
        return null
    }

    const { totals } = data.eInvoiceData

    return (
        <>
            <SectionHeader title={t("label:invoice_summary")} />
            <SummaryRow label={t("label:total_item_amount")} value={`${roundNumberTo2Decimals(totals.lineAmount)} EUR`} />
            <SummaryRow label={t("label:total_surcharges")} value={`${roundNumberTo2Decimals(totals.chargeAmount)} EUR`} />
            <SummaryRow label={t("label:total_discounts")} value={`${roundNumberTo2Decimals(totals.allowanceAmount)} EUR`} />
            <SummaryRow label={t("label:subtotal_net_amount")} value={`${roundNumberTo2Decimals(totals.taxExclusiveAmount)} EUR`} isBold />
            <SummaryRow label={t("label:total_vat_amount")} value={`${roundNumberTo2Decimals(totals.taxAmount)} EUR`} />
            <SummaryRow label={t("label:subtotal_gross_amount")} value={`${roundNumberTo2Decimals(totals.taxInclusiveAmount)} EUR`} isBold />
            <SummaryRow label={t("label:advance_payments")} value={`${roundNumberTo2Decimals(totals.prepaidAmount)} EUR`} />
            <Row className="p-4 text-xs">
                <Col span={12}>
                    <span className="font-medium text-black">{t("label:amount_due")}</span>
                </Col>
                <Col span={12} className="text-right font-medium text-black">
                    <span>{roundNumberTo2Decimals(totals.payableAmount)} EUR</span>
                </Col>
            </Row>
        </>
    )
}
